import Swiper from "swiper/bundle"

let thumbSwiper = new Swiper(".thumbSwiper", {
    slidesPerView: "auto",
});

let mySwiper = new Swiper(".mySwiper", {
    slidesPerView: "auto",
    autoplay: {
        delay: 2500,
    },
    loop: true,
    thumbs: {
        swiper: thumbSwiper
    }
});

new Swiper(".gallSwiper", {
    slidesPerView: "auto",
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 37,
    },
});

let thumbSingleSwiper = new Swiper(".thumbSingleSwiper", {
    slidesPerView: "auto",
});

let SingleSwiper = new Swiper(".singleSwiper", {
    slidesPerView: "auto",
    thumbs: {
        swiper: thumbSingleSwiper
    }
});